import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(chtDate, list) {         
      let actData = chtDate.filter(f=> f.CDATE <= this.timeline.cutoff.date)

      let charts = this.canvasChart
      .append('g')
      .attr('transform', `translate(${list.x}, ${list.y + this.chart.y})`)

      // Bar Chart 
      this.chart.styles.filter(f=> f.type == 'BAR').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : chtDate
        this.draw_BarChart(charts, data, st, i) // -----> below
      })

      // Line Chart 
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : chtDate
        this.draw_LineChart(charts, data, st)
        if(this.chart.lastValue > 0 && st.act == 'Y') this.draw_lastValue(charts, data, st) // -----> below
      })

      if(this.summary.visible=='Y') this.draw_Summary(charts, actData)
    },


    draw_BarChart(selection, _data, _st, _sn) {

      _data.forEach((d,i)=> {
        
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]
        selection
        .append('rect')
        .attr('x', d.bxs[_sn])
        .attr('y', this.chart.height-this.primary.axis(value))
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)

        if(_st.vSize > 0 && value > 0) {
          selection
          .append('text')
          .attr('x', d.bxs[_sn] + (_st.size/2))
          .attr('y', this.chart.height-this.primary.axis(value) -2)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(value)
        }
      })
    },


    draw_LineChart(selection, _data, _st) {
      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => this.secondary.axis(d[_st.code]))

      selection
      .append('path')
      .attr('d', lineFunc(_data))
      .attr('stroke', _st.color).attr('stroke-width', _st.size)
      .attr('fill', 'none').attr('opacity', _st.opacity)
      .style("stroke-dasharray", (_st.ltype, _st.ltype))

      _data.forEach((d,i)=> {
        // Node
        if(_st.node > 0) {
          selection
          .append('circle')
          .attr('cx', d.mx)
          .attr('cy', this.secondary.axis(d[_st.code]))
          .attr('r', _st.node)
          .attr('fill', _st.color).attr('opacity', _st.opacity)
        }
        // Value
        if(_st.vSize > 0 && d[_st.code] > 0) {
          selection
          .append('text')
          .attr('x', d.mx)
          .attr('y', this.secondary.axis(d[_st.code]) -4)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(d[_st.code])
        }
      })
    },


    draw_lastValue(selection, _data, _st) {
      let lastOne = _data.find(f=> f.CDATE == this.timeline.cutoff.date)

      if(_st.type == 'LINE') {
        if(!lastOne) return
        selection
        .append('text')
        .attr('x', lastOne.mx + 5)
        .attr('y', this.secondary.axis(lastOne[_st.code]) + this.chart.lastValue*0.36)
        .attr('font-size', this.chart.lastValue).attr('fill', _st.vColor)
        .text(lastOne[_st.code])
      }
    },


    draw_Summary(selection, _data){
      let summary = this.summary
      let latest = _data.find(f => f.CDATE == this.timeline.cutoff.date)

      let info = selection
      .append('g')
      .attr('id', `info_area`)
      .attr('transform', `translate(${summary.x+.5}, ${summary.y+.5})`)

      info
      .append('rect')
      .attr('width', summary.width).attr('height', summary.height)
      .attr('rx', summary.radius).attr('ry', summary.radius)
      .attr('fill', '#fff').attr('opacity', summary.opacity)
      .attr('stroke', summary.stroke).attr('stroke-width', .5)

      let y = 10
      summary.cols.forEach(d=> {

        info
        .append('text')
        .attr('x', d.mx).attr('y', d.code=='' ? 25 + d.tSize*0.36 : y + d.tSize*0.36)
        .attr('text-anchor', 'middle')
        .attr('fill', summary.tColor).attr('font-size', d.tSize)
        .text(d.name)
        
        if(d.code == '') return

        if(d.name=='Delta') {
          info // Icon
          .append('path')
          .attr('transform', `translate(${d.mx-8}, ${20}) scale(.7)`)
          .attr('d', this.gmx_deltaValue(latest[d.code], 'icon'))
          .attr('fill', this.gmx_deltaValue(latest[d.code]))
          .attr('stroke-width', .5)
          
          info
          .append('text')
          .attr('x', d.mx+2).attr('y', this.summary.display == 'vertical' ? y + d.tSize*0.36 : 25 + d.tSize*0.36)
          .attr('fill', this.gmx_deltaValue(latest[d.code])).attr('font-size', d.tSize)
          .attr('text-anchor', 'start')
          .text(latest[d.code])
        } else {
          info
          .append('text')
          .attr('x', d.tx).attr('y', this.summary.display == 'vertical' ? y + d.tSize*0.36 : 25 + d.tSize*0.36)
          .attr('fill', d.tColor).attr('font-size', d.tSize)
          .attr('text-anchor', d.align)
          .text(latest[d.code])
          .call(this.event_Link, latest, d)
        }

        if(this.summary.display == 'vertical') y = y + d.height
      })
      
    },

  }
}